import { useParams, useNavigate } from "react-router";
import { useFetchTournamentsQuery } from "../../store/tournament/TournamentApi";
import { useGetProfileQuery } from "../../store/auth/AuthApi";
import { FormControl } from "@mui/material";

import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { IconButton, Menu, MenuItem, List, ListItemButton, ListItemText } from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Stack from '@mui/material/Stack';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LinearProgress from '@mui/material/LinearProgress';
import MenuIcon from '@mui/icons-material/Menu';



function TournamentName(tournament)
{
  if (!tournament)
  {
    return null;
  }

  let tournamentName = tournament?.counter + '. ' + tournament?.name + ' vom ' 
    + (new Date(tournament.dateFrom)).toLocaleDateString('de-DE') 
    + ' bis ' + (new Date(tournament.dateUpto)).toLocaleDateString('de-DE');

  if (tournament.closed)
  {
    return (<>{tournamentName}<LockOutlinedIcon /></>);
  }
  else
  {
    return (<>{tournamentName}</>);
  }
};



export function Title({isSideMenuOpen, onSideMenuToggle})
{
  
  const {data:user, isLoading:userIsLoading, isUninitialized:userIsUninitialized} = useGetProfileQuery();
  const {data:tournaments, isLoading:tournamentIsLoading, isUninitialized:tournamentIsUninitialized} = useFetchTournamentsQuery();
  const params = useParams();
  const yearSelector = parseInt(params.year);
  const navigate = useNavigate();
  
  /*
  // Aktuelles Tournament ermitteln: 
  let currentTournament = {};
  if (tournaments&&!tournamentIsLoading){
    currentTournament = tournaments.find((element) => element.year === yearSelector);
  }
  */  

  // Name des Benutzers ermitteln: 
  let userName = 'Loading';
  if (user && !userIsLoading )
    userName = (user.first_name === "")?user.email:user.first_name + "&nbsp;" + user.last_name;
  

  
  // Steuern der Auswahl des Turniers (sofern überhaupt möglich)   
  const [tournamentAnchorElement, setTournamentAnchorElement] = React.useState(null);
  //const [selectedTournament, setSelectedTournament] = React.useState(yearSelector);
  const tournamentMenuOpen = Boolean(tournamentAnchorElement);
  // Das Obermenü
  const handleTournamentMenuClick = event => 
  {
    setTournamentAnchorElement(event.currentTarget);
  };
  const handleTournamentMenuItemClick = (event, year) => 
  {        
    // Lokales Kennzeichen setzen, bei welchem CLub wir jetzt sind
    // setSelectedTournament(year);
    // Danach schließen wir die Übersicht aber auch direkt wieder
    setTournamentAnchorElement(null);      
    // Dann springen wir einfach in das richtige Jahr und sind damit raus: 
    //window.location.href='/' + year;
    // Wir müssen hier navigate verwenden (anstatt window.location), da
    // navigate auch solche Sachen berücksichtigt, die davor stehen).
    navigate('/' + year);

  };
  const handleTournamentMenuClose = () => 
  {
    // Automatisches Schließen
    setTournamentAnchorElement(null);
  };
          

  // Steuern des UserMenüs  
  const [userAnchorElement, setUserAnchorElement] = React.useState(null);        
  const handleUserMenu = event => 
  { 
    setUserAnchorElement(event.currentTarget);
  };      
  const handleUserMenuClose = () => 
  {
    setUserAnchorElement(null);
  };


  if (tournamentIsLoading||tournamentIsUninitialized||userIsLoading||userIsUninitialized)
  {
    return(
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar>
          <Stack justifyContent="center" sx={{ flexGrow: 1 }}><LinearProgress /></Stack>
        </Toolbar>
      </AppBar>
    )
  }
  else
  {  
    // Ausgeben der relevanten Daten, sofern notwendig...
    return(
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar>                       
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={onSideMenuToggle}
            edge="start"
            sx={[
              {
                mr: 2,
              },
              isSideMenuOpen && { display: 'none' },
            ]}
          >
            <MenuIcon />
          </IconButton>          
          <Stack justifyContent="center" sx={{ flexGrow: 1 }}>
            <Typography justifyContent="center" variant="subtitle1" sx={{ flexGrow: 1 }}>
              { user.priviledged?"Mitglied des Organisationsteams":""}
            </Typography>       
          </Stack>   
          <Stack justifyContent="center" sx={{ flexGrow: 1 }}>
            <FormControl>
              <List
                sx={{ flexGrow: 1 }}
                component="nav"
                aria-label="tournament-auswahl"                    
              >
                <ListItemButton
                  id="tournament-button"
                  aria-haspopup="listbox"
                  aria-controls="tournament-menu"
                  aria-label="tournament-auswahl"
                  aria-expanded={tournamentMenuOpen ? 'true' : undefined}
                  onClick={handleTournamentMenuClick}
                >
                  <ListItemText primary={TournamentName(tournaments?.find((element)=>element.year === yearSelector))} />                  
                </ListItemButton>
              </List>
              <Menu
                id="lock-menu"
                anchorEl={tournamentAnchorElement}
                open={tournamentMenuOpen}
                onClose={handleTournamentMenuClose}
                MenuListProps={{
                'aria-labelledby': 'tournament-button',
                role: 'listbox',
                }}
              >
                {
                  tournaments.map(
                    tournament => (
                      <MenuItem
                        key={tournament.year}
                        selected={tournament.year === yearSelector}
                        onClick={(event) => handleTournamentMenuItemClick(event, tournament.year)}
                      >
                        {tournament.counter + '. ' + tournament.name + '  ' + tournament.year}
                      </MenuItem>
                    )
                  )
                }                             
              </Menu> 
            </FormControl>                           
          </Stack>     
          <Typography variant="ButtonTest" align="center">{userName}</Typography> 
          <div>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleUserMenu}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>    
            <Menu
              id="menu-appbar"
              anchorEl={userAnchorElement}
              anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
              }}
              open={Boolean(userAnchorElement)}
              onClose={handleUserMenuClose}
            >
              <MenuItem onClick={handleUserMenuClose}>Profil</MenuItem>
              <MenuItem onClick={handleUserMenuClose}>Konto</MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
    );
  }
}